export default __webpack_public_path__ + "static/media/case.a468a629.png";